import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ead776"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "data-cy", "type", "placeholder", "disabled"]

import { ref, watch } from "vue";
import SuggestionButton from "./suggestionButton.vue";
import CloseBoxIcon from "../svgs/closeBoxIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'percentInput',
  props: {
  hintText: {
    type: String,
    required: true,
  },
  value: {
    type: [Number, String],
    default: 0,
    validator: (val) =>
      typeof val === "number" || typeof val === "string" || val === null,
  },
  label: {
    type: String,
    required: false,
    default: "Label",
  },
  suggestion: {
    type: String,
    required: false,
    default: "",
  },
  classText: {
    type: String,
    default: "tw-text-[#B7B7B7]",
  },
  classInput: {
    type: String,
    default: "tw-text-[11px] tw-font-medium",
  },
  onHover: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isInRange100: {
    type: Boolean,
    default: false,
  },
  isShowRecommend: {
    type: Boolean,
    default: false,
  },
  placeholderInput: {
    type: String,
    default: "center",
  },
  dataCyId: {
    type: String,
    default: "",
  },
  idPercentInput: {
    type: String,
    default: "",
  },
  isShowButtonClear: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "text",
  },
  inputProps: {
    type: Object,
    default: () => ({}),
  },
  isInvalid: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "update:modelValue",
  "focusout",
  "on:blur",
  "clearValue",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "14449264": (__props.placeholderInput)
}))


// eslint-disable-next-line no-unused-vars


const inputRef = ref(null);
let currentValue = ref(
  props.value || props.value === 0 ? (props.value * 100).toFixed() : "",
);

watch(
  () => props.value,
  () => {
    currentValue.value =
      props.value || props.value === 0 ? (props.value * 100).toFixed() : "";
  },
);

const clearData = () => {
  currentValue.value = "";
  emit("clearValue", "");
};

const isMoreThanTwoFixed = (value: string) => {
  const n = value.length;
  const index = value.indexOf(".");
  return index !== -1 && index < n - 3;
};

const isCheckInRange100 = (value: string) => {
  const num = parseFloat(value);
  return num < 0 || num > 100;
};

const updateInput = (e) => {
  if (
    isNaN(e.target.value) ||
    (props.isInRange100 && isCheckInRange100(e.target.value)) ||
    isMoreThanTwoFixed(e.target.value)
  ) {
    return (currentValue.value = currentValue.value.slice(0, -1));
  }
  emit("update:modelValue", e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-flex ${
      __props.isShowRecommend ? 'tw-flex-row-reverse' : ''
    } tw-gap-[15px] tw-items-center ${
      __props.disabled ? 'tw-pointer-events-none' : ''
    }`)
  }, [
    _createElementVNode("div", {
      id: __props.idPercentInput,
      class: _normalizeClass([
        'tw-flex tw-justify-center tw-items-center tw-cursor-text percent-input',
        __props.isInvalid ? '!tw-border-[red]' : '',
        __props.classInput,
      ]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => ((inputRef.value as any)?.focus()))
    }, [
      _withDirectives(_createElementVNode("input", _mergeProps({
        id: `${__props.idPercentInput}-input`,
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentValue) ? (currentValue).value = $event : currentValue = $event)),
        "data-cy": __props.dataCyId,
        type: __props.type,
        placeholder: __props.hintText,
        class: ['tw-flex-1', __props.classText],
        disabled: __props.disabled
      }, __props.inputProps, {
        onInput: updateInput,
        onFocusout: _cache[1] || (_cache[1] = ($event: any) => (emit('focusout', _unref(currentValue)))),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (emit('on:blur'))),
        onPaste: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }), null, 16, _hoisted_2), [
        [_vModelDynamic, _unref(currentValue)]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass([
          _unref(currentValue) || _unref(currentValue)?.toString() === '0' ? 'show' : '',
          __props.classText,
        ])
      }, "%", 2),
      (_unref(currentValue) !== '' && __props.isShowButtonClear)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "close-iten",
            type: "button",
            class: "tw-bg-transparent tw-border-none tw-outline-none tw-ml-[48px]",
            onClick: clearData
          }, [
            _createVNode(CloseBoxIcon, {
              size: 15,
              color: "#FFF",
              "color-x": "#DBDBDB"
            })
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1),
    _createElementVNode("span", {
      class: _normalizeClass(`tw-flex tw-flex-1 tw-flex-row ${
        __props.isShowRecommend ? 'tw-justify-between' : 'tw-justify-start'
      } tw-items-end  tw-gap-[10px]`)
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(`tw-text-[11px] tw-not-italic tw-font-[500] tw-leading-[130%] label ${
          __props.classText ? __props.classText : 'tw-text-[#B7B7B7]'
        }`)
      }, _toDisplayString(__props.label), 3),
      _createVNode(SuggestionButton, {
        value: __props.suggestion,
        style: _normalizeStyle(
          !__props.suggestion || !__props.onHover
            ? {
                visibility: 'hidden',
                position: 'absolute',
              }
            : {}
        ),
        onOnClicked: _cache[5] || (_cache[5] = 
          (value) => {
            updateInput({ target: { value: value.replaceAll('%', '') } });
            emit('focusout');
          }
        )
      }, null, 8, ["value", "style"])
    ], 2)
  ], 2))
}
}

})